import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.profile.title',
    defaultMessage: 'My profile',
    description: 'title of the profile page',
  },
  subNavigation: {
    information: {
      id: 'pages.profile.subNavigation.information',
      defaultMessage: 'Information',
      description: 'label of the information tab on the profile page',
    },
    security: {
      id: 'pages.profile.subNavigation.security',
      defaultMessage: 'Security',
      description: 'label of the security tab on the profile page',
    },
  },
};

export default defineMessages(translations);
